import { inr } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export const PriceBreakdown = ({ p, hours, rate }) => {
  const { t } = useLang();
  const row = (label, val, id, strong) => (
    <div className={`flex justify-between ${strong ? "pt-3 border-t border-dashed border-slate-300 font-bold text-slate-900" : "text-slate-600"}`}>
      <span>{label}</span>
      <span className="font-mono" data-testid={id}>{inr(val)}</span>
    </div>
  );
  return (
    <div className="space-y-2 text-sm rounded-xl bg-[#FAF9F6] border border-slate-200 p-4" data-testid="price-breakdown">
      {row(`${t("price_total")} (${inr(rate)} × ${hours}h, cash)`, p.total, "price-total", true)}
      {row(`Companion share (${100 - p.commission_rate}%)`, p.companion_share, "price-companion-share")}
      {row(`RentMyDate commission (${p.commission_rate}%)`, p.commission, "price-commission")}
    </div>
  );
};
